<script lang="ts">
  export let id = 0;
  let dialog: HTMLDialogElement;
  let scrollY: number;

  $: if (dialog && id) {
    scrollY = window.scrollY;
    dialog.showModal();
    document.body.style.top = `-${scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }

  function closeModal(e?: Event) {
    if (e) {
      e.preventDefault();
    }
    dialog?.close();
    id = 0;
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    requestAnimationFrame(() => {
      window.scrollTo({
        top: scrollY,
        behavior: 'instant'
      });
    });
    // Restore default scroll behavior
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto';
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog
  bind:this={dialog}
  on:close={closeModal}
  on:click={(e) => e.target === dialog && closeModal(e)}>
  <div class="m-auto" role="presentation" on:click|stopPropagation>
    <slot />
    <button class="close" on:click|preventDefault={closeModal}>
      <img src="/theme/citycon2023/images/close-icon.png" alt="close" />
    </button>
  </div>
</dialog>

<style lang="scss">
  .close {
    width: 24px;
    height: 24px;
    border-radius: 0;
    right: 0;
    position: absolute;
    top: 0;
    transition: all 0.2s ease;
    display: flex;
    background-color: var(--color-brand-primary-lighten-6);
    img {
      filter: invert(100%);
      width: 20px;
    }    
    @media screen and (min-width: 768px) {
      display: block;
      width: 48px;
      height: 48px;
      img {
        width: 30px;
      }
    }
  }
  dialog {
    position: relative;
    overflow: visible;
    padding: 24px;
    border: none;
    div {
      max-width: calc(100vw - 50px);
      background-color: #ffffff;
      overflow: auto;

      @media screen and (min-width: 768px) {
        max-height: 90vh;
        width: 420px;
      }
    }
    @media screen and (min-width: 768px) {
      padding: 48px;
    }
  }
  dialog::backdrop {
    background: var(--color-brand-primary);
    opacity: 0.9;
  }
  dialog[open] {
    animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes zoom {
    from {
      transform: scale(0.95);
    }
    to {
      transform: scale(1);
    }
  }
  dialog[open]::backdrop {
    animation: fade 0.2s ease-out;
  }
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  button {
    display: block;
  }
  button:focus {
    outline: none;
  }
</style>
